import { Button, colors, StapleTableRow } from '@insurancemenu/imenu-components-lib';
import React from 'react';
import { Delete, Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { ReplicatedInfoItem, ReplicatedInfoItemWithId } from 'store/general/replicatedInfoDelegate';
import InfoCardTableCell from '../InfoCardTableCell';
import { ReplicatedInfoTableColumn } from '../../index';
import { ButtonsWrapperStyled } from './styles';

interface Props<ItemType extends ReplicatedInfoItem> {
  item: ReplicatedInfoItemWithId<ItemType>;
  columns: ReplicatedInfoTableColumn<ItemType>[];
  onEdit: (itemId: string, item: ReplicatedInfoItemWithId<ItemType>) => void;
  onDelete: (id: string) => void;
}

function InfoCardTableRow<ItemType extends ReplicatedInfoItem>({
  item,
  columns,
  onEdit,
  onDelete,
}: Props<ItemType>): React.ReactNode {
  const onEditItem = (): void => {
    onEdit(item.id, item);
  };

  const onDeleteItem = (): void => {
    onDelete(item.id);
  };

  return (
    <StapleTableRow>
      {columns.map((col, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <InfoCardTableCell key={`cell-${index}`} width={col.width} data={col.getValue(item)} />
      ))}
      <InfoCardTableCell
        width="6rem"
        customLayout={
          <ButtonsWrapperStyled>
            <Button type="icon" color="primary" onClick={onEditItem}>
              <Edit width="2.4rem" height="2.4rem" />
            </Button>
            <Button type="icon" color="custom" customColor={colors.red[600]} onClick={onDeleteItem}>
              <Delete width="2.4rem" height="2.4rem" />
            </Button>
          </ButtonsWrapperStyled>
        }
      />
    </StapleTableRow>
  );
}

export default InfoCardTableRow;
